import { actionTypes as types } from '../constants'
import { firstDefined } from 'utils/utils'
import { pick } from 'lodash-es'

const initialState = {
  // These three state variables control loading states in ModalPage's renderModalShell and renderBlockingSpinner.
  // isFetching is also used to determine whether data is available.
  isFetching: false,
  isFetchUIBlocking: true,
  noContent: false,
  // Display error page
  fetchError: null,
  // Display success page
  fetchSuccessAction: '',
  // Display retry request page
  fetchRetry: null,
  applicationResult: {},
}

const fetchingState = (action) => ({
  isFetching: true,
  isFetchUIBlocking: (firstDefined as any)(action.isFetchUIBlocking, true),
  noContent: Boolean(action.isFetchOnMount),
  fetchError: null,
  fetchSuccessAction: '',
})

const successState = (actionType) => ({
  isFetching: false,
  isFetchUIBlocking: true, // set this to its base state even though it's meaningless when isFetching is false
  noContent: false,
  fetchRetry: null,
  fetchSuccessAction: actionType,
})

function application(state = initialState, action: any = {}) {
  switch (action.type) {
    case types.APPLY_CARD:
      return {
        ...state,
        ...fetchingState(action),
      }

    case types.APPLY_CARD_SUCCESS:
      return {
        ...state,
        ...successState(action.type),
        applicationResult: pick(action.applicationResult, ['eligibility', 'applyForCreate']),
      }

    case types.APPLY_CARD_FAILURE:
      return {
        ...state,
        isFetching: false,
        noContent: false,
        fetchError: action.fetchError,
        fetchRetry: action.fetchRetry,
      }

    default:
      return state
  }
}

export default application
